// extracted by mini-css-extract-plugin
export var dark = "skillset-section-module--dark--UoVR4";
export var light = "skillset-section-module--light--uTcWQ";
export var skillCard = "skillset-section-module--skillCard--+6nf+";
export var skillCardsContainer = "skillset-section-module--skillCardsContainer--3goil";